import { Outlet } from "react-router-dom";

import { Footer } from "../Footer";
import { Navbar } from "../Navbar";
import { ScrollToTop } from "../ScrollToTop";

import styles from "./styles.module.css";

export function MainLayout() {
  return (
    <div className={styles.layout}>
      <ScrollToTop />
      <Navbar />
      <main className={styles.main}>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

export default MainLayout;
